export const config = {
  serviceMenu: false,
  dummyExternalLinks: false,
};
